import styled from "styled-components";

export const FlyoutContainer = styled.li`
  position: relative;
  color: var(--portal-primary);
  font-size: 14px;
  font-weight: 500;
  line-height: 24px;
  white-space: nowrap;
  cursor: pointer;
  user-select: none;
  list-style: none;
`;

export const FlyoutTrigger = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 12px 8px;

  svg {
    width: 14px;
    height: 14px;
    flex-shrink: 0;
  }

  &:hover {
    background: var(--portal-accent);
    transition: 0.2s linear;
  }
`;

interface FlyoutPanelProps {
  openLeft?: boolean;
}

export const FlyoutPanel = styled.ul<FlyoutPanelProps>`
  position: absolute;
  top: 0;
  ${(props) => (props.openLeft ? "right: 100%;" : "left: 100%;")}
  background: #fff;
  border-radius: 4px;
  box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.15);
  padding: 6px 0;
  min-width: 180px;
  list-style: none;
  margin: 0;
  z-index: 1301;
`;

export const FlyoutSubItem = styled.li`
  display: flex;
  align-items: center;
  color: var(--portal-primary);
  font-size: 14px;
  font-weight: 500;
  line-height: 22px;
  padding: 10px 16px;
  white-space: nowrap;
  cursor: pointer;
  list-style: none;
  border-bottom: 1px solid #e9e9e9;

  &:last-child {
    border-bottom: none;
  }

  &:hover {
    background: var(--portal-accent);
    transition: 0.2s linear;
  }
`;
